import React from 'react';

import * as styles from './phonesPreloader.css';

/* istanbul ignore next */
export const PhonesPreloader = () => {
  return <div className={styles['loader']}></div>;
};
